import { SvgIconProps } from './icon-props';

export default function Email({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
			<path d="M30 5H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm0 21H2.05V7.42l13.61 11.8a.54.54 0 0 0 .68 0L30 7.42zm-14-7.7L2.05 6H30z" />
		</svg>
	);
}
